module.exports = __webpack_public_path__ + "static/media/arrow-01.bd202d2c.jpg";